import type { BrowserOptions } from "@sentry/astro";
import type { NodeOptions } from "@sentry/node";

import { VERCEL_ENVS } from "../config/vercelEnvironments";
import { getReleaseName } from "./getReleaseName";

export interface CreateSentryConfigOptions {
  dsn: string | undefined;
  project: string | undefined;
  tracesSampleRate?: number;
  replaysSessionSampleRate?: number;
  replaysOnErrorSampleRate?: number;
  environment?: string;
  debug?: boolean;
  sendDefaultPii?: boolean;
}

export function createSentryClientConfig(
  options: CreateSentryConfigOptions,
): BrowserOptions | undefined {
  const {
    dsn,
    project,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    environment = VERCEL_ENVS.DEVELOPMENT,
    debug = false,
    sendDefaultPii = true,
  } = options;

  if (!dsn || !project) {
    console.warn("Invalid Sentry client-config: No Project or DSN passed.");
    return undefined;
  }

  const releaseName = getReleaseName(project, environment);

  const configOptions: BrowserOptions = {
    debug,
    dsn,
    release: releaseName,
    environment,
    sendDefaultPii,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
  };

  if (debug) console.log("Sentry client config:", configOptions);

  return configOptions;
}

export function createSentryServerConfig(
  options: CreateSentryConfigOptions,
): NodeOptions | undefined {
  const {
    dsn,
    project,
    tracesSampleRate,
    environment = VERCEL_ENVS.DEVELOPMENT,
    debug = false,
    sendDefaultPii = true,
  } = options;

  if (!dsn || !project) {
    console.warn("Invalid Sentry server-config: No Project or DSN passed.");
    return undefined;
  }

  const releaseName = getReleaseName(project, environment);

  const configOptions: NodeOptions = {
    debug,
    dsn,
    release: releaseName,
    environment,
    sendDefaultPii,
    tracesSampleRate,
  };

  if (debug) console.log("Sentry server config:", configOptions);

  return configOptions;
}
